import { Automation } from "../../models/automation/automation.model";
export namespace Automations {
	export class FetchAll {
		static readonly type = "[Automation] Fetch all";
	}

	export class FetchAutomation {
		static readonly type = "[Automation] Fetch Automation";
		constructor(public automationId: number) {}
	}

	export class SetFilter {
		static readonly type = "[Automation] Set Filter";
		constructor(public filter: any) {}
	}

	export class Add {
		static readonly type = "[Automation] Add";
		constructor(public automation: Automation) {}
	}

	export class Update {
		static readonly type = "[Automation] Update";
		constructor(public automationId: number, public automation: Automation) {}
	}

	export class Delete {
		static readonly type = "[Automation] Delete";
		constructor(public automationId: number) {}
	}

	export class ActivateAutomation {
		static readonly type = "[Automation] Activate";
		constructor(public automationId: number) {}
	}

	export class DeactivateAutomation {
		static readonly type = "[Automation] Deactivate";
		constructor(public automationId: number) {}
	}
}
